import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import Grow from '@material-ui/core/Grow';
import Paper from '@material-ui/core/Paper';
import Popper from '@material-ui/core/Popper';
import MenuItem from '@material-ui/core/MenuItem';
import MenuList from '@material-ui/core/MenuList';
import ButtonWithIcon from 'chameleon/ui-stack/ui/buttons/button-with-icon';
import { Clock, Pause, Play } from 'legacy-learnosity-player/src/utility/icons';

import '../utility/proctor.scss';

class DropdownMenu extends Component {
  static displayName = 'DropdownMenu';

  static propTypes = {
    onShowModal: PropTypes.func.isRequired,
    dropdownDisabled: PropTypes.bool,
  };

  static defaultProps = {
    dropdownDisabled: false,
  };

  state = {
    open: false,
  };

  handleToggle = () => {
    this.setState((state) => ({ open: !state.open }));
  };

  handleClose = (event) => {
    if (this.anchorEl.contains(event.target)) {
      return;
    }

    this.setState({ open: false });
  };

  onListClick = (event, type) => {
    const { onShowModal } = this.props;
    onShowModal(type);
    this.handleClose(event);
  };

  // Actions: "Goto", "save & exit", "discard & exit", and "submit & exit" have been removed
  // from the menu. To bring them back, please look at git history.

  render() {
    const { open } = this.state;

    return (
      <div className="proc-dropdown">
        <ButtonWithIcon
          isPrimary
          iconWidth={12}
          iconHeight={8}
          ref={(node) => {
            this.anchorEl = node;
          }}
          accessibility={{
            'aria-owns': open ? 'menu-list-grow' : undefined,
            'aria-haspopup': true,
          }}
          onClick={this.handleToggle}
          disabled={this.props.dropdownDisabled}
          iconOrientation="right"
          icon={open ? 'keyboard_arrow_up' : 'keyboard_arrow_down'} //down
        >
          Actions
        </ButtonWithIcon>
        <Popper
          open={open}
          anchorEl={this.anchorEl}
          placement="bottom-end"
          transition
          disablePortal
        >
          {({ TransitionProps, placement }) => (
            <Grow
              {...TransitionProps}
              id="menu-list-grow"
              style={{
                transformOrigin:
                  placement === 'bottom' ? 'center top' : 'center bottom',
              }}
            >
              <Paper>
                <ClickAwayListener onClickAway={this.handleClose}>
                  <MenuList>
                    <MenuItem onClick={(ev) => this.onListClick(ev, 'pause')}>
                      <Pause /> Pause
                    </MenuItem>
                    <MenuItem onClick={(ev) => this.onListClick(ev, 'resume')}>
                      <Play /> Resume
                    </MenuItem>
                    <MenuItem
                      onClick={(ev) => this.onListClick(ev, 'extendTime')}
                    >
                      <Clock /> Extend Time
                    </MenuItem>
                  </MenuList>
                </ClickAwayListener>
              </Paper>
            </Grow>
          )}
        </Popper>
      </div>
    );
  }
}

export default DropdownMenu;
